module.exports = __webpack_public_path__ + "static/img/aiRoutionPageBG.df28056.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/aiRoutionPageBG.png
// module id = MDbj
// module chunks = 1